type Address = {
  address?: string;
  postal_code?: string;
};

const normalize = (value?: string) => (value || '').trim().toLowerCase();

const normalizePostalCode = (value?: string) =>
  normalize(value).replace(/\s/g, '');

const isSameAsMailingAddress = (
  address: Address | null | undefined,
  mailingAddress: Address,
) =>
  Boolean(
    address?.address &&
    normalize(address.address) === normalize(mailingAddress.address) &&
    normalizePostalCode(address.postal_code) ===
      normalizePostalCode(mailingAddress.postal_code),
  );

export default isSameAsMailingAddress;
